import type { ListTypeListItem } from '@/types/list-type';
import { TOGGLE_TYPE_ALL_CATEGORY_ID } from '@/types/toggle-type';

const sortBySortOrderDesc = (a: ListTypeListItem, b: ListTypeListItem) => 
    b.sortOrder - a.sortOrder;

const sortToggleTypeItems = (
    items: ListTypeListItem[], 
    categoryOrder: string[]
) => {
    if (!categoryOrder.length) {
        return [...items].sort(sortBySortOrderDesc);
    }

    const categoryIndexMap = new Map(categoryOrder.map((id, index) => [String(id), index]));

    return [...items].sort((a, b) => {
        const aIndex = categoryIndexMap.get(String(a.categoryId)) ?? Number.MAX_SAFE_INTEGER;
        const bIndex = categoryIndexMap.get(String(b.categoryId)) ?? Number.MAX_SAFE_INTEGER;
        return aIndex !== bIndex ? aIndex - bIndex : sortBySortOrderDesc(a, b);
    });
};

export const getToggleTypeItemsByCategory = (
    categoryId: number | string,
    toggleTypeItems: ListTypeListItem[],
    categoryOrder: string[] = []
) => {
    const isAllCategory = categoryId === TOGGLE_TYPE_ALL_CATEGORY_ID;

    if (isAllCategory) {
        return sortToggleTypeItems(toggleTypeItems, categoryOrder);
    }

    return toggleTypeItems
        .filter((item) => item.categoryId === categoryId)
        .sort(sortBySortOrderDesc);
};